<div class="row">
  <!-- Stripe Snackbar -->
  <roma-shared-stripe-snackbar></roma-shared-stripe-snackbar>

  <roma-mf-time-tracking
    (onClickDownload)="download($event)"
    (onUpdateStopwatch)="refreshList()"
  ></roma-mf-time-tracking>
</div>

<div class="clockhours-filters">
  <div class="left-div">
    <div class="filter-wrapper">
      <button
        class="btn sm"
        [ngClass]="{ active: view === clockHourViewRef.Week }"
        (click)="changeClockHourView(clockHourViewRef.Week)"
      >
        {{ 'clockHour.weekly' | translate }}
      </button>
      <button
        class="btn sm"
        [ngClass]="{ active: view === clockHourViewRef.Month }"
        (click)="changeClockHourView(clockHourViewRef.Month)"
      >
        {{ 'clockHour.monthly' | translate }}
      </button>
    </div>
    <div class="wrapper-pagination">
      <button
        class="btn arrow-btn prev"
        (click)="
          view === clockHourViewRef.Week
            ? changeWeek(firstWeekDay, 'prev')
            : changeMonth(selectedMonth - 1, 'prev')
        "
      >
        <img src="assets/icons/gl_arrow_left.svg" />
      </button>
      <div *ngIf="view === clockHourViewRef.Week" class="filter-info">
        {{ firstWeekDay }}
        {{
          lastWeekDay < firstWeekDay
            ? stringRemainingMonth
            : (stringMonth | titlecase)
        }}
        - {{ lastWeekDay }} {{ stringMonth | titlecase }}
      </div>
      <div *ngIf="view === clockHourViewRef.Month" class="filter-info">
        {{ stringMonth | titlecase }} {{ currentYear }}
      </div>
      <button
        class="btn arrow-btn next"
        (click)="
          view === clockHourViewRef.Week
            ? changeWeek(lastWeekDay + 1, 'next')
            : changeMonth(selectedMonth + 1, 'next')
        "
      >
        <img src="assets/icons/gl_arrow_left.svg" />
      </button>
      <button
        class="btn arrow-btn"
        style="margin-left: 4px"
        (click)="goToToday()"
      >
        {{ 'clockHour.today' | translate }}
      </button>
    </div>
  </div>

  <roma-shared-download-btn
    *ngIf="clockHours?.length && !(resize$ | async)?.payload?.mobile"
    [showDownloadExcel]="true"
    [showDownloadPdf]="true"
    (download)="download($event)"
    [showDownloadIcon]="false"
    [showArrowIcon]="'down'"
    [ngClass]="{ 'is-hidden': isLoading }"
  ></roma-shared-download-btn>
</div>

<div class="row">
  <div class="col--12">
    <div class="total-info-header">
      <div *ngIf="isLoadingMetrics" class="col-12">
        <roma-loading></roma-loading>
      </div>
      <div *ngIf="!isLoadingMetrics" class="wrapper-total-hours">
        <div class="wrapper-row">
          <div class="col-md-3 card-wrapper">
            <roma-time-display
              [clockHours]="userMetrics.workedHours"
              [clockHoursLabel]="'clockHour.totalHours' | translate"
              [icon]="'clock-fill'"
              [clickable]="false"
              [totalHours]="userMetrics.contractHours"
            ></roma-time-display>
          </div>
          <div class="col-md-3 card-wrapper">
            <roma-time-display
              [clockHours]="userMetrics.remainingHours"
              [clockHoursLabel]="
                'person.create.form.hoursToClockIn' | translate
              "
              [icon]="'to-clock-in'"
              [clickable]="userMetrics.contractHours === null"
              (updateMetrics)="updateMetrics()"
            ></roma-time-display>
          </div>
          <div class="col-md-3 card-wrapper">
            <roma-time-display
              [clockHours]="userMetrics.extraHours"
              [clockHoursLabel]="'person.create.form.overtime' | translate"
              [icon]="'clock-overtime'"
              [clickable]="userMetrics.contractHours === null"
              [fullWidthMobile]="true"
              (updateMetrics)="updateMetrics()"
            ></roma-time-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrapper-overlay" style="display: contents">
  <ng-container *ngIf="(resize$ | async)?.payload?.mobile">
    <roma-list-mobile-clock-hour
      *ngIf="!isLoading && clockHours"
      [data]="clockHours"
      (actions)="makeMobileActions($event)"
      [canClockIn]="!clockInWithStopwatchMandatory"
      typeView="clockHours"
    ></roma-list-mobile-clock-hour>
  </ng-container>

  <div
    id="containerTable"
    class="containerTable"
    [ngStyle]="{ 'margin-top': tableMarginTop }"
    (scroll)="checkScroll($event)"
  >
    <div class="my-4">
      <div *ngIf="isLoading" class="col-12">
        <roma-loading></roma-loading>
      </div>

      <div
        *ngIf="!(resize$ | async)?.payload?.mobile"
        class="col-12"
        [ngClass]="{ 'is-hidden': isLoading || !clockHours?.length }"
      >
        <roma-table
          class="table responsive-table"
          type="clockHours"
          [ngStyle]="tableStyles"
          idModule="CLOCK_HOUR_MODULE"
          [appendSettings]="'NO'"
          [tagNotAvailable]="'activity.notAvailable' | translate"
          [data]="clockHours"
          [displayedColumns]="columns"
          [showActions]="true"
          (wantEdit)="launchModalClockHourEdit($event)"
          (wantDelete)="deleteClockHour($event)"
          [canClockIn]="!clockInWithStopwatchMandatory"
        >
        </roma-table>
      </div>
    </div>
  </div>
</div>
